import type { RouteObject } from "react-router";
import { Beitraege } from "./Beitraege";
import { Board } from "./Board";
import { ContentFreigabe } from "./ContentFreigabe";
import { Kampagne } from "./Kampagne";
import { Kooperation } from "./Kooperation";
import { KooperationBearbeiten, KooperationNeu } from "./KooperationFormular";
import { Kooperationen } from "./Kooperationen";
import { NachMarke } from "./NachMarke";
import { BerichtVorschau } from "./Marke";
import { BestandImport } from "../stammdaten/BestandImport";

/** Wege der Kooperationen (docs/OBERFLAECHE_PLAN.md): Liste, Board, nach Marke (Hub), Kampagne, anlegen, Bestand übernehmen (0064), Detail mit ?monat=, bearbeiten, Content prüfen. */
export const kooperationenRoutes: RouteObject[] = [
  { path: "kooperationen", element: <Kooperationen /> },
  { path: "kooperationen/board", element: <Board /> },
  { path: "kooperationen/nach-marke", element: <NachMarke /> },
  // 0068: Beiträge des ganzen Teams
  { path: "kooperationen/beitraege", element: <Beitraege /> },
  { path: "kooperationen/kampagne/:campaignId", element: <Kampagne /> },
  // 0073: Bericht für die Marke als Vorschau (wie der Link) mit PDF
  { path: "kooperationen/bericht/:reportId", element: <BerichtVorschau /> },
  { path: "kooperationen/neu", element: <KooperationNeu /> },
  { path: "kooperationen/import", element: <BestandImport kind="kooperationen" /> },
  { path: "kooperationen/:dealId", element: <Kooperation /> },
  { path: "kooperationen/:dealId/bearbeiten", element: <KooperationBearbeiten /> },
  { path: "kooperationen/:dealId/content", element: <ContentFreigabe /> },
];
